import React, { Component } from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { closeModal } from "../../actions/modalAction";
import { createAward } from "../../actions/awardAction";
import { withRouter } from "react-router-dom";

import { Form, Button } from "semantic-ui-react";
import TextInput from "../form/TextInput";
import NumberInput from "../form/NumberInput";
import {
  //composeValidators,
  combineValidators,
  isRequired,
} from "revalidate";
import CloseButton from "../common/CloseButton";
//
const validate = combineValidators({
  head: isRequired("Heading"),
});

class AwardCreate extends Component {
  onSubmit = (values) => {
    this.props.createAward(values);
  };
  render() {
    const { handleSubmit, pristine, reset, submitting } = this.props;

    //*********************************
    return (
      <div
        className="card-form border-radius marginBottom min-max-width"
        style={{ margin: "auto" }}
      >
        <CloseButton closeBtn={this.props.closeModal} />
        <div>
          {/**/}

          <div
            style={{
              textAlign: "center",
              fontSize: "1.5rem",
              fontWeight: "bold",
              padding: "15px",
              color: "dodgerblue",
            }}
          >
            {/*  */}
            Create Award
            {/*  */}
          </div>

          {/**/}
          <div className="">
            <div className=" label" style={{ textAlign: "left" }}>
              <Form
                style={{ padding: 20 }}
                onSubmit={handleSubmit(this.onSubmit)}
              >
                <div>
                  <span className="color-mandatory">* </span>Mandatory Fields
                </div>
                <label>Heading</label>
                <span className="color-mandatory"> * </span>
                <Field
                  name="head"
                  type="text"
                  component={TextInput}
                  placeholder="Heading"
                />

                <label>Position</label>
                <Field
                  name="position"
                  type="number"
                  component={NumberInput}
                  placeholder="1/2/3 so on"
                />

                <br />

                <Button
                  color="olive"
                  type="submit"
                  disabled={pristine || submitting}
                >
                  Submit
                </Button>
                <Button
                  color="orange"
                  type="button"
                  disabled={pristine || submitting}
                  onClick={reset}
                >
                  Clear Values
                </Button>

                <br />
              </Form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    state,
    userA: state.auth.userA,
  };
};

export default connect(
  mapStateToProps,

  { createAward, closeModal }
)(
  reduxForm({
    form: "AwardCreate", // a unique identifier for this form
    validate,
  })(withRouter(AwardCreate))
);
